<template>
    <div class="col-sm-4 col-md-7 div-center">
        <div class="list-group">
            <span class="list-group-item d-flex justify-content-between align-items-center" v-for="(item, index) in messages" :key="index">
                {{item.creationtime}}<br/>{{item.data}}
                <button type="button" class="btn btn-danger btn-sm" @click="actDeleteMessage(index)">{{$t('favo.delete')}}</button>
            </span>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  created() {
      this.$store.dispatch('actGetMessages', this.getIdentity)
  },

  computed: {
    messages: function() {
      return this.getMessages.map(function(elm) {
        let jobj = JSON.parse(elm)
        if (jobj.type == 'data') {
            return {
              "creationtime": jobj.creationtime, 
              "data": jobj.data.body
              }
        } else {
            return {
              "creationtime": jobj.creationtime, 
              //"data": "{ "+jobj.notification.title+", "+jobj.notification.body + " }"
              "data": jobj.notification.body
              }
        }
       return jobj
      })
    },
    ...mapGetters([
      'getIdentity',
      'getMessages'
    ])
  },

  methods: {
    ...mapActions([
      'actDeleteMessage'
    ]),
  }

}
</script>

<style scoped>
@import '../assets/css/custom.css'
</style>


// WEBPACK FOOTER //
// src/pages/Message.vue